// Sourced from @symbo.ls/utils, not the monolithic 'smbls' barrel — these are
// plain object helpers (@symbo.ls/utils/object.js) re-exported by smbls
// verbatim. This file is a canvas-editor paste handler (user-triggered, not
// boot), but it's still statically reachable from the shell entry via
// shared/functions/index.js's barrel, so the smaller import keeps the eager
// chunk from paying for the whole framework bundle. See
// workspace/functions/workspaceProjects.js for the same established pattern.
import { deepMerge, createNestedObject, deepClone } from '@symbo.ls/utils'

export async function handleLayerPaste(key, layerCode, _) {
  const data = this.getCanvasScope()
  const schema = deepClone(data.selected.state.parse())
  const { activeLayer } = data

  const updateDiff = activeLayer
    ? createNestedObject(activeLayer.slice(1), { [key]: layerCode || {} })
    : { [key]: layerCode || {} }

  deepMerge(schema.value, updateDiff)
  delete schema.code
  delete schema.codeStr

  const layerInfo = activeLayer ? `${activeLayer.slice(-1)} layer` : ''
  const componentType = this.getType(schema)
  const commitMessage = `${key} layer is pasted in ${layerInfo} at ${schema.key} ${componentType.slice(0, -1)}`

  this.sdk.updateItem(componentType, schema, { message: commitMessage })

  setTimeout(async () => {
    // await this.call('updateComponentOnCanvas', schema, {
    //   updatePane: true
    // })
  }, 0)

  if (activeLayer) {
    data.activeLayer.push(key)
  } else {
    data.activeLayer = ['content', key]
  }
}

export function getCodeToCopy() {
  const data = this.getCanvasScope()

  if (data.activeLayer) {
    return this.call('getActiveLayerCode')
  }
  return this.call('getFullComponentCode')
}

export function getActiveLayerCode() {
  const data = this.getCanvasScope()
  const { activeLayer } = data
  const value = deepClone(data.selected.state.value)
  const layerCode = activeLayer.reduce((acc, item) => acc[item] || acc, value)
  const key =
    activeLayer.length > 1 ? activeLayer[activeLayer.length - 1] : value.key

  return {
    metadata: 'copiedFromSymbols',
    key,
    layerCode
  }
}

export function getFullComponentCode() {
  const data = this.getCanvasScope()
  const code = deepClone(data.selected.state.parse())
  code.metadata = 'copiedFromSymbols'
  return code
}

export function getUsedComponentsKeys(
  DEFAULT_COMPONENT,
  allUsed,
  type,
  uniqUses = []
) {
  let collectedKeys = []

  allUsed.forEach((key) => {
    if (!DEFAULT_COMPONENT[key]) {
      const keyElement = this.call('getSchemaItem', key, type)

      if (keyElement && !uniqUses[keyElement]) {
        collectedKeys.push(key)

        collectedKeys = [
          ...collectedKeys,
          ...getUsedComponentsKeys.call(
            this,
            DEFAULT_COMPONENT,
            keyElement.uses,
            keyElement.type,
            collectedKeys
          )
        ]
      }
    }
  })

  return collectedKeys
}
